import React, { useState } from 'react';

const ChooseUs = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "How long does it take to find a tenant?",
            answer: "With our extensive database of applicants and proactive marketing approach, we typically secure high-quality tenants within 7-14 days. We prioritize finding the right tenant over the quickest one."
        },
        {
            question: "How do you ensure tenants are reliable?",
            answer: "We use a rigorous referencing process checking credit history, employment status, and previous landlord references. We also guarantee all right-to-rent and compliance checks are completed before handing over keys."
        },
        {
            question: "Are there any hidden management fees?",
            answer: "No. Transparency is at the core of our brand. We provide straightforward, flat-fee structures with no hidden markups on maintenance work or unexpected administrative charges."
        }
    ];

    return (
        <section style={{ backgroundColor: '#f9fcfb', padding: '100px 0', position: 'relative', overflow: 'hidden' }}>
            {/* Decorative background circle */}
            <div style={{
                position: 'absolute',
                top: '-10%',
                right: '-5%',
                width: '400px',
                height: '400px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(37,181,121,0.08) 0%, rgba(255,255,255,0) 70%)',
                zIndex: 0
            }}></div>

            <div className="auto-container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row clearfix align-items-center">
                    <div className="col-lg-5 col-md-12 col-sm-12" style={{ marginBottom: '40px' }}>
                        <div style={{ paddingRight: '40px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                <span style={{ width: '40px', height: '2px', backgroundColor: '#25b579', marginRight: '15px' }}></span>
                                <h5 style={{ color: '#25b579', fontWeight: '700', fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>
                                    TRUSTED EXPERTISE
                                </h5>
                            </div>
                            <h2 style={{ color: '#0a3d62', fontSize: 'clamp(2.5rem, 4vw, 3.2rem)', fontWeight: '300', marginBottom: '30px', lineHeight: '1.2' }}>
                                Why landlords <br/><strong style={{ fontWeight: '700' }}>choose Imperial</strong>
                            </h2>
                            <p style={{ color: '#555555', fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '40px' }}>
                                We understand that your property is a significant investment. Our approach is built on removing the stress of lettings through proactive management, strict compliance, and transparent communication.
                            </p>
                            <a href="/contact" style={{ 
                                display: 'inline-flex', 
                                alignItems: 'center',
                                backgroundColor: '#0a3d62', 
                                color: '#ffffff', 
                                padding: '16px 40px', 
                                fontWeight: '700', 
                                borderRadius: '6px', 
                                textDecoration: 'none', 
                                transition: 'all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)',
                                boxShadow: '0 10px 20px rgba(10, 61, 98, 0.15)',
                                position: 'relative',
                                zIndex: 10
                            }}
                               onMouseEnter={(e) => {
                                   e.currentTarget.style.background = '#25b579';
                                   e.currentTarget.style.transform = 'translateY(-3px)';
                                   e.currentTarget.style.boxShadow = '0 15px 25px rgba(37, 181, 121, 0.25)';
                               }}
                               onMouseLeave={(e) => {
                                   e.currentTarget.style.background = '#0a3d62';
                                   e.currentTarget.style.transform = 'translateY(0)';
                                   e.currentTarget.style.boxShadow = '0 10px 20px rgba(10, 61, 98, 0.15)';
                               }}
                            >
                                Get a Free Valuation
                                <i className="fas fa-arrow-right" style={{ marginLeft: '10px' }}></i>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-sm-12">
                        <div style={{ padding: '0 15px' }}>
                            {faqs.map((faq, index) => (
                                <div key={index} style={{ 
                                    marginBottom: '20px', 
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '5px 25px',
                                    boxShadow: activeIndex === index ? '0 15px 30px rgba(0,0,0,0.06)' : '0 5px 15px rgba(0,0,0,0.03)',
                                    border: '1px solid rgba(0,0,0,0.03)',
                                    transition: 'all 0.4s ease'
                                }}>
                                    <button 
                                        onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                                        style={{ 
                                            width: '100%', 
                                            background: 'none', 
                                            border: 'none', 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center', 
                                            padding: '20px 0', 
                                            cursor: 'pointer',
                                            textAlign: 'left'
                                        }}
                                    >
                                        <h4 style={{ 
                                            color: activeIndex === index ? '#25b579' : '#0a3d62', 
                                            fontSize: '1.25rem', 
                                            fontWeight: '600', 
                                            margin: 0, 
                                            transition: 'color 0.3s' 
                                        }}>
                                            <span style={{ color: '#25b579', marginRight: '15px', opacity: 0.5 }}>0{index + 1}.</span> 
                                            {faq.question}
                                        </h4>
                                        <div style={{
                                            width: '30px', 
                                            height: '30px', 
                                            borderRadius: '50%', 
                                            backgroundColor: activeIndex === index ? '#25b579' : '#f0f5f3',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s'
                                        }}>
                                            <i className={`fas fa-${activeIndex === index ? 'minus' : 'plus'}`} style={{ color: activeIndex === index ? '#fff' : '#0a3d62', fontSize: '0.8rem' }}></i>
                                        </div>
                                    </button>
                                    <div style={{ 
                                        maxHeight: activeIndex === index ? '200px' : '0', 
                                        overflow: 'hidden', 
                                        transition: 'max-height 0.4s cubic-bezier(0, 1, 0, 1)',
                                        opacity: activeIndex === index ? 1 : 0
                                    }}>
                                        <p style={{ color: '#666666', lineHeight: '1.7', fontSize: '1.05rem', margin: '0 0 25px 0', paddingLeft: '35px', borderLeft: '2px solid rgba(37,181,121,0.2)' }}>
                                            {faq.answer}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ChooseUs;
